import { GenericEntityWorkspacePage } from "./shared/GenericEntityWorkspacePage";
import { pilotBoardConfig } from "./shared/entityWorkspaceBoardConfigs";

export function PilotWorkspacePage({ userName = "Utilisateur" }: { userName?: string }) {
  return <GenericEntityWorkspacePage config={pilotBoardConfig} userName={userName} />;
}
